export { default } from './svg/sidebar-icon.svg';
